// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "org_sms_number".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { smsNumberStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "org_sms_number" table (1:1 with a DB row, on the wire). */
export const orgSmsNumberAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    phoneNumber: z.string().nullable(),
    twilioSid: z.string(),
    country: z.string().nullable(),
    tenDlcCampaignSid: z.string().nullable(),
    messagingServiceSid: z.string().nullable(),
    status: z.enum(smsNumberStatusValues),
    isChatbotActive: z.boolean(),
    smsAssistantEnabled: z.boolean(),
    provisionedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=orgSmsNumber.js.map